<script setup lang="ts">
import type { UmbracoFormField } from 'types/blocks';

const props = defineProps<{
  field: UmbracoFormField;
}>();

const { showLabel } = useForm();
const formStore = useFormStore();

const preValues = props.field.preValues || [];
const defaultValue = props.field.settings?.defaultValue?.trim();

const selectValue = ref(
  defaultValue && preValues.some((p) => p.value === defaultValue) ? defaultValue : preValues[0]?.value || ''
);

watch(selectValue, (newValue) => {
  formStore.setFieldValue(props.field.alias, newValue);
});

onMounted(() => {
  if (selectValue.value) {
    formStore.setFieldValue(props.field.alias, selectValue.value);
  }
});
</script>

<template>
  <Label
    v-if="showLabel(field)"
    class="form__label flex w-full flex-col"
  >
    {{ field.caption }}

    <SelectRoot
      v-model="selectValue"
      class="w-full"
      :disabled="formStore.isDisabled"
      :name="field.alias"
    >
      <SelectTrigger>
        <SelectValue />
        <BaseIcon
          prefix="arrows"
          name="chevron-down"
        />
      </SelectTrigger>

      <SelectPortal>
        <SelectContent
          :body-lock="false"
          position="popper"
          side="bottom"
          class="form-dropdown-content"
          :side-offset="-50"
          :side-flip="false"
          style="width: var(--reka-select-trigger-width)"
        >
          <SelectScrollUpButton />
          <SelectViewport class="form-dropdown-viewport">
            <template
              v-for="(item, index) in field.preValues"
              :key="`${item.value}-${item.caption}-${index}`"
            >
              <SelectItem
                v-if="item.value"
                :value="item.value"
                class="form-dropdown-item"
              >
                <SelectItemText>
                  {{ item.caption }}
                </SelectItemText>
              </SelectItem>
            </template>
          </SelectViewport>
          <SelectScrollDownButton />
        </SelectContent>
      </SelectPortal>
    </SelectRoot>
  </Label>
</template>
